import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Yellow welcome strip shown above the top nav for logged-out visitors on the
 * public marketing site. Links are placeholders (`/coming-soon`) until the
 * "what is this" and owner add-flat pages exist.
 */
const AnnouncementBar = () => {
  const { t } = useTranslation();

  return (
    // `data-testid` czytają bramki układu (check-nachodzenie-mapy, shot.mjs): pasek jest tylko u
    // gościa POZA bramką dostępu, więc build z VITE_ENV=production go nie ma — a mapa na
    // telefonie jest wtedy o ~80 px wyższa niż u prawdziwego gościa (30.09).
    <div data-testid="pasek-ogloszen" className="bg-[#fdf6b2] text-sm text-foreground">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-2 gap-y-1 px-4 py-2 text-center">
        {/* Shorter copy on mobile so the strip stays on one line. */}
        <span>
          🎉 <span className="md:hidden">{t('announcement.message_short')}</span>
          <span className="hidden md:inline">{t('announcement.message')}</span>
        </span>
        <Link to="/coming-soon" className="strefa-dotyku relative font-medium underline underline-offset-2 hover:no-underline">
          🤔 <span className="md:hidden">{t('announcement.whats_this_short')}</span>
          <span className="hidden md:inline">{t('announcement.whats_this')}</span>
        </Link>
        {/* The owner add-flat shortcut is desktop-only (per the mockup). */}
        <Link to="/coming-soon" className="hidden font-medium underline underline-offset-2 hover:no-underline md:inline-flex">
          🏠 {t('announcement.add_flat')}
        </Link>
      </div>
    </div>
  );
};

export default AnnouncementBar;
